import API from "..";

async function search(url) {
  try {
    const response = await API.get(url);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

async function searchMachines(url) {
  try {
    const response = await API.get(url);
    return response.data;
  } catch (e) {
    throw e.response;
  }
}

export { search, searchMachines };
